import { Component, Input, Optional, SkipSelf, ViewEncapsulation, ElementRef } from '@angular/core';
import { PhxBackground } from '../../types';
import { PhxDividerOrientation, PhxDividerMarginX, PhxDividerMarginY } from './phx-divider.types';
import { PHOENIX_CONTEXTS, PhxContextService } from '../../services/phx-context-service';
import { PHX_SPACING, PHX_BACKGROUND } from '../../constants';
@Component({
  selector: 'phx-divider',
  exportAs: 'phxDivider',
  template: '<ng-container></ng-container>',
  styleUrls: ['./phx-divider.component.scss'],
  host: {
    class: 'phx-divider',
    '[class.phx-divider-horizontal]': `phxOrientation === 'horizontal'`,
    '[class.phx-divider-vertical]': `phxOrientation === 'vertical'`,
    '[class.phx-divider-bg-standard]': `phxBackground === PHX_BACKGROUND.STANDARD`,
    '[class.phx-divider-bg-medium]': `phxBackground === PHX_BACKGROUND.MEDIUM`,
    '[class.phx-divider-bg-bold]': `phxBackground === PHX_BACKGROUND.BOLD`,
    '[class.phx-divider-bg-summary]': `phxBackground === PHX_BACKGROUND.SUMMARY`,
    '[class.phx-divider-bg-inverted]': `phxBackground === PHX_BACKGROUND.INVERTED`,
    '[class.phx-divider-bg-overlay]': `phxBackground === PHX_BACKGROUND.OVERLAY`,
    '[class.phx-divider-bg-dark]': `phxBackground === PHX_BACKGROUND.DARK`,
    '[class.phx-divider-margin-x-none]': `phxMarginX === PHX_SPACING.NONE`,
    '[class.phx-divider-margin-x-xxs]': `phxMarginX === PHX_SPACING.XXS`,
    '[class.phx-divider-margin-x-smd]': `phxMarginX === PHX_SPACING.SMD`,
    '[class.phx-divider-margin-x-md]': `phxMarginX === PHX_SPACING.MD`,
    '[class.phx-divider-margin-x-mdl]': `phxMarginX === PHX_SPACING.MDL`,
    '[class.phx-divider-margin-x-lg]': `phxMarginX === PHX_SPACING.LG`,
    '[class.phx-divider-margin-x-xl]': `phxMarginX === PHX_SPACING.XL`,
    '[class.phx-divider-margin-y-none]': `phxMarginY === PHX_SPACING.NONE`,
    '[class.phx-divider-margin-y-xxs]': `phxMarginY === PHX_SPACING.XXS`,
    '[class.phx-divider-margin-y-smd]': `phxMarginY === PHX_SPACING.SMD`,
    '[class.phx-divider-margin-y-md]': `phxMarginY === PHX_SPACING.MD`,
    '[class.phx-divider-margin-y-mdl]': `phxMarginY === PHX_SPACING.MDL`,
    '[class.phx-divider-margin-y-lg]': `phxMarginY === PHX_SPACING.LG`,
    '[class.phx-divider-margin-y-xl]': `phxMarginY === PHX_SPACING.XL`,
    '[class.phx-divider-margin-y-xxl]': `phxMarginY === PHX_SPACING.XXL`,
    '[style.height]': 'height',
    '[class.phx-filter]': 'phxStyleType === PHOENIX_CONTEXTS.FILTER',
  },
  encapsulation: ViewEncapsulation.None,
})
export class PhxDividerComponent{
  @Input() phxOrientation: PhxDividerOrientation = 'horizontal';
  @Input() phxBackground: PhxBackground = PHX_BACKGROUND.STANDARD;
  @Input() phxMarginX: PhxDividerMarginX;
  @Input() phxMarginY: PhxDividerMarginY;
  @Input() phxDividerHeight: string = '';

  public readonly PHX_SPACING = PHX_SPACING;
  public readonly PHX_BACKGROUND = PHX_BACKGROUND;
  public readonly PHOENIX_CONTEXTS = PHOENIX_CONTEXTS;
  public phxStyleType: PHOENIX_CONTEXTS;
  
  constructor(@Optional() @SkipSelf() private contextService: PhxContextService, private host: ElementRef<HTMLElement>) {
    this.phxStyleType = contextService?.getType();
  }
  
  public get height (): string {
    return this.phxOrientation === 'vertical' ? this.phxDividerHeight : '1px';
  };

  getHostElement(): HTMLElement {
    return this.host.nativeElement;
  }
}
